import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import LoginRequest from './LoginRequest'

function OrderForwardTimeCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Aika asetettu</h2>
    </div>
  )
}

function AddOrderForwardTime(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    orderForwardTime: '',
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer

  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    const dataToServer = {
      ...userData,
      orderForwardTime: Number(userData.orderForwardTime),
    }
    try {
      await axios.post(`${SERVER_URI}/set_order_forward_time/`, dataToServer, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'ADD_IDLE_ORDER_FORWARD_TIME',
        data: { newOrderForwardTime: dataToServer.orderForwardTime },
      })
      setShow(!show)
    } catch (e) {
      console.log('Error in setting an idle order forward time.', e)
    }
  }
  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Aseta aika </h2>
              <form className='timeLimit_form' onSubmit={(e) => doSubmit(e)}>
                <label className='label_add' htmlFor='timeLimit'>
                  Aika minuutteina:
                </label>
                <input
                  type='number'
                  id='orderForwardTime'
                  name='orderForwardTime'
                  onChange={onChange}
                  placeholder='Aika'
                  min='0'
                  max='5000000000'
                  required
                ></input>{' '}
                minuuttia<span className='validity'></span>{' '}
                <br className='desktop-break' />
                <input
                  type='submit'
                  id='gradient_Button'
                  value='Aseta aikaraja'
                />
              </form>
            </div>
          )}
          {show && (
            <OrderForwardTimeCreatedMessage handleClose={props.handleClose} />
          )}
        </div>
      </div>
    </div>
  )
}

function IdleOrderForwardTime(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  //const [isloggedIn, setIsloggedIn] = useState(true);
  //let storage = window.localStorage;
  //let userToken = storage.getItem("admin_token")

  /* useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }
  return (
    <div className='configurations'>
      {isOpen && (
        <AddOrderForwardTime
          dispatch={props.dispatch}
          handleClose={togglePopUp}
        />
      )}
      <h3>Kuittamaattoman tilauksen eteenpäinvälitysaika</h3>
      <div className='rides'>
        {props.orderForwardTime === undefined ? (
          <LoginRequest />
        ) : props.orderForwardTime.length === 0 ? (
          <h4>Ei aikarajaa</h4>
        ) : (
          <div className='customer_list'>
            {props.orderForwardTime} minuutin välein
            <br />
          </div>
        )}
      </div>
      <button id='gradient_Button' onClick={togglePopUp}>
        Aseta aika
      </button>
    </div>
  )
}

export default IdleOrderForwardTime
